import {
    StorageContext,
    StorageState,
    UpdateStorageState,
} from 'context/storage/types';

export type EntityIdentifier = string | number;
// eslint-disable-next-line @typescript-eslint/ban-types
export type EntityType = object;

export type UpdateEntityState<S> = UpdateStorageState<S>;

export type EntityState<
    Identifier extends EntityIdentifier,
    Type extends EntityType
> = StorageState<Record<Identifier, Type>>;

export type EntityContext<
    Identifier extends EntityIdentifier,
    Type extends EntityType
> = StorageContext<Record<Identifier, Type>>;

export const PROVIDER_NAME = 'EntityContextProvider';
